import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import ProductImagesContainer from "../components/ProductImagesContainer";
import AddToCartQuantity from "../components/AddToCartQuantity";
import Categories from "../components/Categories";
import AskExpert from "../components/AsxExpert";
import ProductMiniature from "../components/ProductMiniature";
import ProductDescription from "../components/ProductDescription";
import { toCamelCase, formatCurrency } from "../Utils/Helpers";
import { useProducts } from "../context/ProductsContext";
import { usePurchase } from "../context/PurchaseContext";


const CustomProductDetails = () => {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const { loadAllProducts } = useProducts();
  const { setProduct, setQuantity: setContextQuantity } = usePurchase();
  const [listRelated, setListRelated] = useState([]);

  // Hardcoded BADASS BBQS LOVE RUB product
  const product = {
    Id: "LOVE-RUB-001",
    Model: "LOVE-RUB-2024",
    Title: "LOVE RUB",
    Price: 15.99,
    brand: "BADASS BBQS",
    Image: "https://badassbbqs.com/custom-product.png",
    
    Category: ["Seasonings", "BBQ Rubs", "Love Rubs"],
    Specifications: [
      { "Net Weight": "11.5 OZ. (326 g)" },
      { "Brand": "BADASS BBQS" },
      { "Tagline": "GIVE YOUR MEAT SOME LOVE" },
      { "Ingredients": "Salt, Sugar, Paprika, Spices, Garlic, Onion, Love" },
      { "Allergens": "None" },
      { "Made In": "USA" }
    ],
    description: `Spice up your grill game with the ultimate flavor companion: LOVE RUB by Badass BBQs. This bold and savory seasoning blend is specially crafted to transform every cut of meat into a mouthwatering masterpiece. Whether you're firing up ribs, brisket, chicken, pork, or even veggies, LOVE RUB delivers a deep, rich taste that hits all the right notes – sweet, smoky, salty, and spicy.\n\nWith a colorful tie-dye label that brings the party to your spice rack, LOVE RUB isn't just a seasoning – it's a vibe. Made for backyard BBQ kings, pitmasters in the making, and anyone who knows that great BBQ starts with great rub, this 11.5 oz (326 g) bottle is packed with premium ingredients and no BS.\n\nWhy You'll Love It:\n• 🔥 Bold flavor profile that enhances meat without overpowering it\n• 🌿 High-quality spices blended for maximum flavor punch\n• 🐖 Perfect for ribs, pork shoulders, brisket, chicken, and more\n• 🎯 Great for dry rubs, marinades, or as a finishing dust\n• 💯 No artificial crap – just pure, badass BBQ flavor\n\nWhether you're smoking low and slow or searing hot and fast, LOVE RUB brings the heat and the heart. Shake it generously, rub it in with passion, and let the magic happen. Because your meat deserves more than just salt and pepper — it deserves LOVE.\n\nDirections:\nGenerously coat meat with LOVE RUB before cooking. For best results, let it sit for 15–30 minutes (or overnight in the fridge) before grilling or smoking.\n\nLegal disclaimers and warnings:\nThis product is not intended to diagnose, treat, cure, or prevent any disease. The information provided is for educational purposes only and is not medical advice. Always consult a healthcare professional before making any health-related decisions.`
  };

  useEffect(() => {
    const fetchRelated = async () => {
      try {
        const allProducts = await loadAllProducts();
        const filtered = allProducts
          .filter(p => p.Id !== product.Id && p.Image)
          .sort(() => 0.5 - Math.random())
          .slice(0, 10);
        setListRelated(filtered);
      } catch (e) {
        setListRelated([]);
      }
    };
    fetchRelated();
  }, [product.Id, loadAllProducts]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true } },
      { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } }
    ],
  };

  return (
    <div className="p-6 max-w-6xl mx-auto overflow-x-hidden">
      <Categories categories={product.Category} />
      <div className='block sm:hidden'>
        <p className="text-md text-gray-600 mr-2">ID: {product.Id} <span>|</span> Model: {product.Model}</p>
        <h1 className="text-[20px] font-bold mb-2 leading-6">{product.Title}</h1>
        <span className="block mb-2 font-bold text-lg">{product.brand}</span>
        <span className="block mb-5 text-pink-600 font-semibold">{product.Specifications[2]["Tagline"]}</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-10 pl-0 space-x-5 items-center">
        {/* Left Side - Product Image */}
        <div className="block justify-center items-start">
          <img src={product.Image}  className="rounded-lg"/>
        </div>
        {/* Right Side - Product Information */}
        <div className="flex flex-col justify-between">
          <div>
            <div className="items-center hidden sm:flex">
              <p className="text-md text-gray-600 mr-2">ID: {product.Id}</p>
              <span>|</span>
              <p className="text-md ml-2">Model: {product.Model}</p>
            </div>
            <h1 className="text-3xl font-bold mb-2 hidden md:flex">{product.Title}</h1>
            <span className="block mb-2 font-bold text-lg">{product.brand}</span>
            <span className="block mb-5 text-pink-600 font-semibold">{product.Specifications[2]["Tagline"]}</span>
            <p className="text-[15px] font-light text-gray-500 line-through -mb-2 mt-[40px] md:mt-0">
              {formatCurrency(product.Price * 1.15)}
            </p>
            <p className="text-[30px] font-semibold text-black mb-4">
              {formatCurrency(product.Price)}
            </p>
            <p className='font-bold'>In Stock</p>
            <p className='text-gray-500'>Ships within 24 hours</p>
            <p className="affirm-as-low-as text-[15px] my-[20px]" data-page-type="product" data-amount={product.Price*100}></p>
            <div className="flex flex-row gap-4 items-center w-full xl:w-[80%]">
              <select
                id="quantity"
                value={quantity}
                onChange={e => {
                  const newQuantity = Number(e.target.value);
                  setQuantity(newQuantity);
                  setContextQuantity(newQuantity);
                }}
                className="border border-gray-300 rounded px-2 py-1 h-12"
              >
                {[1,2,3,4,5,6,7,8,9,10].map(num => (
                  <option key={num} value={num}>{num}</option>
                ))}
              </select>
              <button
                onClick={() => {
                  setProduct(product);
                  setContextQuantity(quantity);
                  navigate('/custom-product-checkout');
                }}
                className="flex-1 bg-red text-white px-4 py-2 rounded font-bold hover:bg-white hover:text-red border border-red h-12"
              >
                BUY NOW
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr></hr>
      <h2 className='text-left text-[35px] font-bold mt-5 mb-5 ml-2'>Related Products</h2>
      <Slider {...settings} className='mb-10 relative z-0 mx-auto max-w-[100%]'>
        {listRelated.map((product) => (
          <div key={product.Id} className="px-2 flex">
            <ProductMiniature product={product} />
          </div>
        ))}
      </Slider>
      <hr></hr>
      {/* Product Description */}
      <div className="mt-6 block sm:grid grid-cols-[auto_200px] gap-10">
        <div>
          <h2 className="text-lg font-semibold mb-5">Description</h2>
          <ProductDescription product={product} />
        </div>
        <div>
          <AskExpert />
        </div>
      </div>
      {/* Specifications */}
      <div className="mt-6">
        <h2 className="text-lg font-semibold mt-5 mb-5">Specifications</h2>
        <table className="min-w-full border-collapse border border-gray-300">
          <tbody>
            {product.Specifications
              .reduce((rows, spec, index, specs) => {
                if (index % 2 === 0) {
                  rows.push(specs.slice(index, index + 2));
                }
                return rows;
              }, [])
              .map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className="grid grid-cols-4 md:table-row"
                >
                  {row.map((spec, cellIndex) => {
                    const [name, value] = Object.entries(spec)[0];
                    return (
                      <React.Fragment key={cellIndex}>
                        <td className="border border-gray-300 p-2 font-semibold col-span-2 md:table-cell">
                          {name}
                        </td>
                        <td className="border border-gray-300 p-2 col-span-2 md:table-cell">
                          {value}
                        </td>
                      </React.Fragment>
                    );
                  })}
                  {row.length < 2 && (
                    <React.Fragment>
                      <td className="border border-gray-300 p-2 col-span-2 md:table-cell"></td>
                      <td className="border border-gray-300 p-2 col-span-2 md:table-cell"></td>
                    </React.Fragment>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomProductDetails;